import { Component, signal } from '@angular/core';
import { AddressEdit } from './Akte/Controlls/AddressEdit'
import * as moment from 'moment';
import { ToastsContainer } from './Akte/Services/Toasts/ToastsContainer';

@Component({
  selector: 'app-root',
  templateUrl: './app.html',
  standalone: false,
  styleUrl: './app.css'
})
export class App {
  protected readonly title = signal('Frontend');
}
